import { createContext } from "react";

export type SidebarData = {
    potentialClientCount: number;
    needs2FASetup: boolean;
    successMarker: {
        initialFocusReady: boolean;
        unreadCheckInCount: number;
    };
};

export const defaultSidebarData: SidebarData = {
    potentialClientCount: 0,
    needs2FASetup: false,
    successMarker: {
        initialFocusReady: false,
        unreadCheckInCount: 0,
    },
};

export const initialCoachSidebarDataContext = {
    ...defaultSidebarData,
    reloadSidebarData: async () => {},
};

export const CoachSidebarDataContext = createContext(
    initialCoachSidebarDataContext,
);
